export const csvDefaultHeaderValueGetter = (headerName, injectables, field) => {
    const { i18n } = injectables;
    return i18n.formatMessage({
        id: `app.campaigns.reports.grid.column.header.message.${field}`,
        defaultMessage: headerName,
    });
};
